import React from 'react';
import {
  Button,
  LoadingButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import { IModalBasicProps } from '../../../models/common/modal';
import { getHyphenatedPhoneNumber } from '../../../utils/general';

export interface IResendMultiInviteModalProps {
  onResendMultiInvites: () => void;
  isLoading: boolean;
  pendingT2CAuthPhoneNumbers: string[];
}

export const ResendMultiInviteModal = ({
  hideModal,
  onResendMultiInvites,
  isLoading,
  pendingT2CAuthPhoneNumbers,
}: IResendMultiInviteModalProps & IModalBasicProps) => {
  const isPlural = pendingT2CAuthPhoneNumbers.length > 1;

  const ending = (plural: boolean) => {
    return plural ? 's' : '';
  };
  const headerText = `Resend Text2Confirm Invite${ending(isPlural)}`;
  const bodyText = `A text message will be sent to the number${ending(
    isPlural,
  )} below. The user${ending(
    isPlural,
  )} must reply to the text message to confirm Text2Confirm enrollment.`;
  const resendBtnText = `Resend Invite${ending(isPlural)}`;

  const formattedT2CNumbers = pendingT2CAuthPhoneNumbers
    .map((number) => {
      return getHyphenatedPhoneNumber(number);
    })
    .join(', ');

  return (
    <>
      <ModalHeader onClose={hideModal}>
        <span data-testid="header-element">{headerText}</span>
      </ModalHeader>
      <ModalBody>
        <Typography variant="body-base" data-testid="body-element">
          {bodyText}
        </Typography>
        <div className="sui-mt-4">
          <Typography
            variant="body-base"
            weight="bold"
            data-qm-mask=""
            data-testid="phone-element"
          >
            {formattedT2CNumbers}
          </Typography>
        </div>
      </ModalBody>
      <ModalFooter position="end">
        <div className="sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto">
          <Button variant="secondary" onClick={hideModal}>
            Cancel
          </Button>
          <LoadingButton
            loading={isLoading}
            variant="primary"
            onClick={onResendMultiInvites}
            data-testid="resend-multi-invites-btn"
          >
            {resendBtnText}
          </LoadingButton>
        </div>
      </ModalFooter>
    </>
  );
};

ResendMultiInviteModal.displayName = 'ResendMultiInviteModal';
